import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { Page } from "src/app/model/Page";
import { PaymentReconciliationModel } from "src/app/model/PaymentReconciliationModel";
import { PaymentReconciliationService } from "src/app/services/payment-reconciliation.service";
import { PaymentReconciliationModalComponent } from "../payment-reconciliation-modal/payment-reconciliation-modal.component";

@Component({
  selector: "app-secure-payment-reconciliation",
  templateUrl: "./payment-reconciliation.component.html",
  styleUrls: ["./payment-reconciliation.component.scss"],
})
export class PaymentReconciliationComponent implements OnInit, AfterViewInit {
  page: Page<PaymentReconciliationModel>;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<PaymentReconciliationModel> = new MatTableDataSource();
  displayedColumns: string[] = [
    "id",
    "applicationNo",
    "transactionId",
    "applicantName",
    "appFormStatus",
    "appPaymentStatus",
    "transactionStatus",
    "transactionDate",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  constructor(
    private router: Router,
    private paymentReconciliationService: PaymentReconciliationService,
    private _snackBar: MatSnackBar,
    private modalCtrl: ModalController
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.required, Validators.minLength(3)])
    });
  }

  resetFilter() {
    this.filterForm.controls['filterText'].setValue(null);
    this.page = null;
    this.dataSource = new MatTableDataSource(null);
    setTimeout(() => {
      this.paginator.pageIndex = 0;
      this.paginator.length = 0;
    });
  }

  onSearch() {
    if (this.filterForm.valid) {
      this.isLoading = true;
      this.paymentReconciliationService.fetchPaymentReconciliationByFilter(this.currentPage, this.pageSize, this.filterForm.value.filterText).subscribe((page) => {
        this.isLoading = false;
          this.page = page;
          this.dataSource = new MatTableDataSource(page.content);
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = page.totalElements;
          });
          this.isSearchDisabled = false;
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
          this.isSearchDisabled = false;
        }
      );
    }
    else {
      this._snackBar.open("Please enter Filter text (minimum - 3 char) for Audit Trail", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isSearchDisabled = false;
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onSearch();
  }

  async onCheckTransactionStatus(transactionId: string) {
    this.paymentReconciliationService.fetchPaymentReconciliationByTransactionId(transactionId)
    .subscribe(async (obj) => {
      const modal = await this.modalCtrl.create({
        component: PaymentReconciliationModalComponent,
        cssClass: 'master-modal',
        componentProps: {
            obj: obj
        }
      });
      modal.present();

      const { data, role } = await modal.onWillDismiss();
        
      if (role === 'close') {
        this.onSearch();
      } 
    });
  }

  viewClassStatus(status: string) {
    if(status === 'APPLICATION_RECEIVED' || status === 'PAYMENT_RECEIVED' || status === 'SUCCESS') {
        return 'bg-green-400';
    }
    else if(status === 'PAYMENT_NOT_RECEIVED' || status === 'PENDING') {
        return 'bg-yellow-400';
    }
    else if(status === 'APPLICATION_REJECTED' || status === 'FAILURE') {
        return 'bg-pink-600';
    }
    else {
        return '';
    }
  }
}